const mql = window.matchMedia('only screen and (max-width: 768px)');

// Early console interception for dev mode
(function() {
  const urlParams = new URLSearchParams(window.location.search);
  const testParam = urlParams.get('test') === 'true';
  const storedState = localStorage.getItem('dev-console-modal-open') === 'true';
  
  if (testParam || storedState) {
    // Store original console methods if not already stored
    if (!window.__devOriginalConsole) {
      window.__devOriginalConsole = {
        log: console.log.bind(console),
        error: console.error.bind(console),
        warn: console.warn.bind(console),
        info: console.info.bind(console),
        debug: console.debug.bind(console)
      };
    }
    
    // Store logs globally until modal is ready
    window.__devConsoleLogs = window.__devConsoleLogs || [];
    window.__devConsoleModalInstance = null;
    const maxLogs = 1000;
    
    const addLog = (type, args) => {
      const timestamp = new Date().toLocaleTimeString();
      const message = args.map(arg => {
        if (typeof arg === 'object') {
          try {
            return JSON.stringify(arg, null, 2);
          } catch (e) {
            return String(arg);
          }
        }
        return String(arg);
      }).join(' ');
      
      // Filter out logs with [klarna-osm] or [Klaviyo / Onsite]
      if (message.includes('[klarna-osm]') || message.includes('[Klaviyo / Onsite]')) {
        return;
      }
      
      window.__devConsoleLogs.push({ type, message, timestamp });
      
      if (window.__devConsoleLogs.length > maxLogs) {
        window.__devConsoleLogs.shift();
      }
      
      // Notify modal if it exists
      if (window.__devConsoleModalInstance && window.__devConsoleModalInstance.isOpen) {
        window.__devConsoleModalInstance.renderLogs();
      }
    };
    
    // Intercept console methods immediately (only if not already intercepted)
    if (!window.__devConsoleIntercepted) {
      console.log = function(...args) {
        addLog('log', args);
        window.__devOriginalConsole.log.apply(console, args);
      };
      
      console.error = function(...args) {
        addLog('error', args);
        window.__devOriginalConsole.error.apply(console, args);
      };
      
      console.warn = function(...args) {
        addLog('warn', args);
        window.__devOriginalConsole.warn.apply(console, args);
      };
      
      console.info = function(...args) {
        addLog('info', args);
        window.__devOriginalConsole.info.apply(console, args);
      };
      
      console.debug = function(...args) {
        addLog('debug', args);
        window.__devOriginalConsole.debug.apply(console, args);
      };
      
      window.__devConsoleIntercepted = true;
    }
  }
})();

window.Currency = (function () {

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.select = this.querySelector('select');
    if (this.select) { 
      this.select.addEventListener('change', this.onSelectChange.bind(this));
    }
    if (this.input) {
      this.maxValue = this.input.max;
      this.minValue = this.input.min;
      this.disableButtons();
      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);
    
      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }
    this.changeEvent = new Event('change', { bubbles: true })
    
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );


  }

  onChange(event) {
    this.disableButtons();
  }

  onSelectChange() {
    const selectValue = this.select.options[this.select.selectedIndex].value;
    this.input.value = selectValue;
  }

  

  disableButtons(event) {

    this.currentValue = this.input.value;

    if (this.maxValue == this.currentValue) {
      this.querySelector('[name="plus"]').disabled = true;
    } else {
      this.querySelector('[name="plus"]').disabled = false;
    }

    if (this.minValue == this.currentValue) {
      this.querySelector('[name="minus"]').disabled = true;
    } else {
      this.querySelector('[name="minus"]').disabled = false;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) { 
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    if(!detailsElement) return;
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.setVar('loadPage')
  }

  setVar(when) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    this.usps = this.header.querySelector('.usp-bar');
    if (this.usps) {
      this.uspOffset = this.usps.offsetHeight;
    } else {
      this.uspOffset = 0;
    }
    var headerPosition = '0';
    if (when == 'loadPage') {
      headerPosition = this.header.offsetHeight + this.uspOffset; 
    } else {
      headerPosition = this.header.getBoundingClientRect().bottom;
    }
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(headerPosition - this.borderOffset - this.uspOffset)}px`);
  }

  openMenuDrawer(summaryElement) {
    this.setVar('openMenu');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if(!event.code) return;
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model, modal-thumbnails')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);


class ModalHover extends ModalOpener {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;

    button.addEventListener('mouseenter', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));

      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-hover', ModalHover);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);
    


    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }


  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1],
        previousPage: previousPage,
        previousElement: this.sliderItemsToShow[previousPage - 1]
      }}));
    }


    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }


  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.button = this.querySelector('button[type="button"]');
    if (this.button) {
      
      this.button.addEventListener('click', this.onButtonClick.bind(this));
    }
  }

  onVariantChange(event) {
    if (event.target.type === 'number') {
      this.validateInput();
      this.findVariantFromSize(event);
    }
    if (event.target.type === 'number') return;
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }

    this.updateCustomSize(event);
  }

  findVariantFromSize() {
    if (!event.target.dataset.findVariant) return;  
    const sizeValue = parseInt(event.target.value);
    const selectOptions = this.querySelector(`select option[data-custom-size-label*="${this.button.dataset.custom}"]`).closest('select').querySelectorAll('option');

    for (const option of selectOptions) {
      const valueText = option.value;
      // Extract the numerical bounds from the option value
      const matches = valueText.match(/(\d+)-(\d+)/);
  
      if (matches) {
        const lowerBound = parseInt(matches[1]);
        const upperBound = parseInt(matches[2]);
  
        // Check if the sizeValue falls within the range
        if (sizeValue >= lowerBound && sizeValue <= upperBound) {
          option.selected = true;
          this.dispatchEvent(new Event('change'));
          return; // Exit the loop and function once the correct option is found
        }
      }
    }
  
    console.log('No matching option found for the size value.');

  }

  validateInput() {
    const input = this.querySelector('input[type="number"]');
    const inputError = input.closest('div').querySelector('.input__row-error');
    var val = parseFloat(input.value);
    var min = parseFloat(input.min);
    var max = parseFloat(input.max);
    if (val > max) {
      input.value = input.max;
      inputError.classList.remove('hidden');

    } else {
      if (val < min) {
        input.value = input.min;
        inputError.classList.remove('hidden');
      } else {
        inputError.classList.add('hidden');
      }
    }
    

  }

  onButtonClick(event) {
    let selectOption = '';
    const customSizeInput = this.querySelector('.product-form__input-custom input');
    if (event.currentTarget.dataset.type === 'variant-finder') {
      selectOption = this.querySelector(`select option[data-custom-size-label*="${this.button.dataset.custom}"]`);
      
    }
    if (event.currentTarget.dataset.type === 'variant-selector') {
      selectOption = this.querySelector(`select option[data-custom-size-label="${this.button.dataset.custom}"]`);
    }

    if (this.button.getAttribute('aria-expanded') === 'true') {
      this.hideCustomSize(selectOption.closest('select'));
      selectOption.closest('select').selectedIndex = 0;
      customSizeInput.disabled = true;
      this.dispatchEvent(new Event('change'));


    } else {
      this.showCustomSize(selectOption.closest('select'));
      // select selectOption
      selectOption.closest('select').selectedIndex = selectOption.index;
      customSizeInput.value = '';
      customSizeInput.disabled = false;
      this.dispatchEvent(new Event('change'));

    }




  }




  updateCustomSize(event) {
    if(event.target.nodeName !== 'SELECT') return;
    const customSize = this.querySelector('.product-form__input-custom');
    if (!customSize) return;
    const selectOption = this.querySelector(`select option[data-custom-size-label="${this.button.dataset.custom}"]`);
    if (selectOption && selectOption.selected) {
      this.showCustomSize(selectOption.closest('select'));
    } else {
      this.hideCustomSize(selectOption.closest('select'));
    }

  }

  showCustomSize(select) {
    this.querySelector('.product-form__input-custom input').disabled = false;
    select.closest('.product-form__input').classList.add('hidden');
    this.querySelector('.product-form__input-custom').classList.remove('hidden');
    this.button.setAttribute('aria-expanded', 'true');

  }

  hideCustomSize(select) {
    select.closest('.product-form__input').classList.remove('hidden');
    this.querySelector('.product-form__input-custom').classList.add('hidden');
    this.button.setAttribute('aria-expanded', 'false');

    select.dispatchEvent(new Event('change'));

    
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section}-gallery .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    let separator = this.dataset.url.includes('?product') ? '&' : '?';
  
    window.history.replaceState({}, '', `${this.dataset.url}${separator}variant=${this.currentVariant.id}`);  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('.hiddenId');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
        input.removeAttribute('hidden');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
        input.setAttribute('hidden', true);
      }
    });
  }


  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const optionsId = `options-${this.dataset.section}`;
        const configId = `config-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const customId = `custom-${this.dataset.section}`;
        
        let destination = document.getElementById(id);
        const optionsDestination = document.getElementById(optionsId);
        const customDestination = document.getElementById(customId);
        const source = html.getElementById(id);
        const optionsSource = html.getElementById(optionsId);
        const customSource = html.getElementById(customId);

        const sourceConfig = html.getElementById(configId);
        const destinationConfig = document.getElementById(configId);
        if (sourceConfig && destinationConfig) destinationConfig.innerHTML = sourceConfig.innerHTML;





        if (source.classList.contains('hidden')) {
          destination = document.getElementById(`price-${this.closest('product-configurator').dataset.section}`);
        }


        if (source && destination) destination.innerHTML = source.innerHTML;
        if (optionsSource && optionsDestination) optionsDestination.innerHTML = optionsSource.innerHTML;

        // commented out to keep the new value. not sure if this affects the 'old' function.
        // if (customSource && customDestination) customDestination.innerHTML = customSource.innerHTML;
        if (customSource && customDestination) {

          const oldValue = customDestination.querySelector('input').value;
          customDestination.innerHTML = customSource.innerHTML;
          customDestination.querySelector('input').value = oldValue;
        }


        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if(!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class CartAddButton extends HTMLElement {
  constructor() {
    super();
    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
    if(this.cartNotification){
      this.cart = this.cartNotification;
    } else {
      this.cart = this.cartDrawer;
    }
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        cartItems.addProduct(this.dataset.id, 1);
      } else {
        this.addProduct(this.dataset.id, 1);
      }
    });
  }
  addProduct(id, quantity) {
    this.setAttribute('aria-disabled', true);
    this.classList.add('loading');
    //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    const body = JSON.stringify({
      id,
      quantity,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }

      this.cart.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.classList.remove('loading');
      this.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
  }
}
customElements.define('cart-add-button', CartAddButton);




class CartShippingCosts extends HTMLElement {
  constructor() {
    super();
    this.calculateShippingCosts();
  }

  init() {
    this.shippingCostElem = this.querySelector('[data-shipping-costs]');
    this.totalPriceElem = this.querySelector('[data-price]');
    this.originalPrice = parseInt(this.totalPriceElem.dataset.price);
    this.goodieNotification = document.querySelector('.cart-drawer__goodie-text');
  }

  calculateShippingCosts() {
    fetch(`${routes.cart_url}/prepare_shipping_rates.json?shipping_address%5Bzip%5D=${window.shipping.postal_code}&shipping_address%5Bcountry%5D=${window.shipping.country}`, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(),
    })
      .then(response => response.json())
      .then(data => {
         return fetch(
          `${routes.cart_url}/async_shipping_rates.json?shipping_address%5Bzip%5D=${window.shipping.postal_code}&shipping_address%5Bcountry%5D=${window.shipping.country}`,
          {
            method: 'GET',
            body: JSON.stringify()
          }
        );
      })
      .then(response => response.json())
      .then(rates => {
        this.init();
        const firstShippingRate = rates.shipping_rates[0];
        if (!firstShippingRate) {
          this.querySelector('#shipping-costs').classList.add('hidden');
        } else {

          const newTotalPrice = (firstShippingRate.price * 100) + this.originalPrice;
          this.shippingCostElem.innerHTML = window.Currency.formatMoney(firstShippingRate.price, window.currency.currencyFormat);
          this.totalPriceElem.innerHTML = window.Currency.formatMoney(newTotalPrice, window.currency.currencyFormat);  
        }
      });
  }
}

customElements.define('cart-shipping-costs', CartShippingCosts);


class FaqSection extends HTMLElement {
  constructor() {
    super();

    this.categories = this.querySelectorAll('.faq-content-titles button');
    this.sections = Array.from(this.querySelectorAll('.faq-content-content .faq-category'));
    this.detailList = this.querySelectorAll('details');

    this.categories.forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.detailList.forEach(
      (detail) => detail.addEventListener('toggle', this.onDetailToggle.bind(this))
    );

    this.openActiveElement();

  }

  onDetailToggle(event) {
    this.activeElement = event.target.dataset.link;
    window.history.replaceState({ }, '', `${this.dataset.url}#${this.activeElement}`);

  }

  openActiveElement(event) {
    const hash = window.location.hash;
    if (hash) {
      const detail = this.querySelector(`details[data-link="${hash.substring(1)}"]`);
      if (detail) {
        const closestSection = detail.closest('section');
        const blockToExpand = closestSection.dataset.expand;
        this.openSection(blockToExpand);
        detail.open = true;
      }
    }
  }

  openSection(blockToExpand) {
    this.categories.forEach((button) => {
      if (button.dataset.expand !== blockToExpand) {
        button.classList.remove('is-active');
      } else {
        button.classList.add('is-active');
      }
    });
    const section = this.sections.find((section) => section.dataset.expand === blockToExpand);
    if (section) {
      section.classList.add('is-active');
      this.sections.forEach((section) => {
        if (section.dataset.expand !== blockToExpand) {
          section.classList.remove('is-active');
        }
      });
    }
    
  }

  onButtonClick(event) {
    const dataExpand = event.target.dataset.expand;
    const blockToExpand = event.target.dataset.expand;
    this.openSection(blockToExpand);

    
  }

}

customElements.define('faq-section', FaqSection);

class ModalPopup extends ModalDialog {
  constructor() {
    super();

    this.timeOut = this.dataset.start;
    this.testMode = this.dataset.test;
    this.cookieName = this.dataset.cookie;

    if (this.testMode) {
      this.show();
    }

    if(localStorage.getItem(this.cookieName) === 'true') return;

    this.init.bind(this)();
    
  }

  init() {
    setTimeout(function(){ this.show() }.bind(this), this.timeOut);
  }

  show() {
    super.show();
    localStorage.setItem(this.cookieName, true);
  }
}
customElements.define('modal-popup', ModalPopup);

class QuickViewModal extends ModalDialog {
  constructor() {
    super();

    this.handle = this.dataset.handle;
    this.modalContent = this.querySelector('[id^="QuickViewInfo-"]');
    this.moved = true;

  }


  hide(preventFocus = false) {
    const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cartNotification) cartNotification.setActiveElement(this.openedBy);
    this.modalContent.innerHTML = '';

    if (preventFocus) this.openedBy = null;
    super.hide();
  }

  show(opener) {
    opener.setAttribute('aria-disabled', true);
    opener.classList.add('loading');
    opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    fetch(opener.getAttribute('data-product-url'))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.setInnerHTML(this.modalContent, responseHTML.querySelector('.shopify-section').innerHTML);


        this.preventVariantURLSwitching();
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        
      })
      .finally(() => {
        opener.removeAttribute('aria-disabled');
        opener.classList.remove('loading');
        opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;
  }

  preventVariantURLSwitching() {
    const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
    if (!variantPicker) return;

    variantPicker.setAttribute('data-update-url', 'false');
  }








}

customElements.define('quick-view-modal', QuickViewModal);

class FooterBlock extends HTMLElement {
  constructor(){
    super();
    this.summary = this.querySelector('summary');
    this.details = this.querySelector('details');
    if (this.dataset.mobile == 'closed') {
      this.init();
    }

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));

    
    if (!this.summary) return;
    
    mql.addEventListener('change', this.init.bind(this));
    
  }
  
  init() {
    if (mql.matches) {
      this.details.open = false;
    } else {
      this.details.open = true;
    }
  }

  onSummaryClick(event) {
    if (!mql.matches) {
      event.preventDefault();
    }
  }

}

customElements.define('footer-block', FooterBlock);


function setVw() {
  let vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}

setVw();
window.addEventListener('resize', setVw);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class FeaturedCollections extends HTMLElement {
  constructor() {
    super();
    this.buttonList = this.querySelectorAll('[data-expand]');
    this.buttonList.forEach((button) => {
      button.addEventListener('click', (event) => {
        this.onButtonClick(event);
      });
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    this.showCorrectCollection(event);
    this.showCorrectButton(event);
  }

  showCorrectCollection(event) {
    document.querySelectorAll('.featured-collection__block').forEach((block) => {
      block.classList.add('hidden');
    });
    document.getElementById(event.currentTarget.dataset.expand).classList.remove('hidden');
  }

  showCorrectButton(event) {
    document.querySelector('.featured-collection__titles button.active').classList.remove('active');
    event.currentTarget.classList.add('active');
  }


}

customElements.define('featured-collections', FeaturedCollections);

class ShareCartButton extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.successMessage = this.querySelector('[id^="ShareMessage"]');
    this.button = this.querySelector('button');

    this.button.addEventListener('click', this.copyToClipboard.bind(this));

      
  }

  
  
  copyToClipboard(event) {
    event.preventDefault();
    navigator.clipboard.writeText(this.input.value).then(() => {
      this.successMessage.classList.remove('hidden');
      // this.successMessage.textContent = window.accessibilityStrings.shareSuccess;
      setTimeout(() => {
        this.successMessage.classList.add('hidden');
      }, 5000);
    });
  }
  
}
 
customElements.define('share-cart-button', ShareCartButton);



function changeCalendlyLinks() {
  document.querySelectorAll('a[href*="calendly.com"]').forEach((link) => {
  // check if link is already changed by checking if the href is nog empty 
  if (!link.href) return;
  // get href from href
  const href = link.getAttribute('href');
  // set onclick
  link.setAttribute('onclick', `Calendly.initPopupWidget({url: '${href}'});return false;`);
  // change href to empty string
  link.setAttribute('href', '');


}
);
}

window.changeCalendlyLinks();

class FetchProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.renderProductInfo();
  }

  executeScripts(sourceElement, destinationElement) {
    // Remove existing scripts in the destination to prevent duplicates
    destinationElement.querySelectorAll('script').forEach(script => script.remove());

    // Append and execute scripts found in the source element, excluding JSON
    Array.from(sourceElement.querySelectorAll('script')).forEach(originalScript => {
      if (originalScript.type.toLowerCase() === 'application/json' ||
          (originalScript.textContent.trim().startsWith('{') || originalScript.textContent.trim().startsWith('['))) {
        console.log('Skipping JSON script');
        return; // Skip JSON scripts
      }

      const script = document.createElement('script');
      if (originalScript.src) {
        script.src = originalScript.src;
      } else {
        script.textContent = originalScript.textContent;
      }
      script.defer = originalScript.defer;
      destinationElement.appendChild(script);
    });
  }

  renderProductInfo() {
    const url = this.getAttribute('data-url');
    const sectionId = this.getAttribute('data-section');

    fetch(url)
      .then(response => response.text())
      .then(htmlText => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        
        const destination = document.querySelector(`#MainContent`);
        const source = doc.querySelector(`#MainContent`);
        const mainContent = doc.querySelector('#MainContent'); // Adjust the selector as necessary

        if (source && destination) {
          this.executeScripts(mainContent, destination);

          // set url:
          window.history.replaceState({}, '', `${this.dataset.url}`);  
          destination.innerHTML = source.innerHTML;
        }

        // source.querySelector('product-configurator').init();
        
      })
      .catch(error => {
        console.error("Failed to render product info:", error);
      });
  }
}

customElements.define('fetch-product', FetchProduct);

class ConfigViewer extends HTMLElement {
  constructor() {
      super();
      // Bind methods to ensure proper 'this' context
      this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  connectedCallback() {
      // Ensure the element contains the required button and target
    this.button = this.querySelector('.button--view-config');
    this.closeButton = this.querySelector('.button--close-config');
      this.productFormButtons = this.querySelector('.product-form__buttons-wrap');

      if (this.button && this.productFormButtons) {
          // Attach the click event listener to the button
          this.button.addEventListener('click', this.handleButtonClick);
      }
      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.handleButtonClick);
      }
    
  }


  handleButtonClick() {
      // Toggle the 'active' class on the product-form__buttons
      this.productFormButtons.classList.toggle('active');
  }
}

// Define the custom element
customElements.define('config-viewer', ConfigViewer);

class DynamicContent extends HTMLElement {
  constructor() {
    super();
  }

  fetchContent(url) {
    const variantSectionUrl = `${this.dataset.baseUrl}${url}&section_id=cart-configurator`;

    fetch(variantSectionUrl)
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.shopify-section');
        this.renderContent(sectionInnerHTML);
      });
  }

  renderContent(sectionInnerHTML) {

    this.outerHTML = sectionInnerHTML.innerHTML;
  }


  
}
 
customElements.define('dynamic-content', DynamicContent);

class CartShareLink extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const products = [];
    const propertiesMap = new Map();

    urlParams.forEach((value, key) => {
      if (key.startsWith('properties_')) {
        const variantId = key.replace('properties_', '');
        if (!propertiesMap.has(variantId)) propertiesMap.set(variantId, []);
        propertiesMap.get(variantId).push(value);
      }
    });

    const variantSeenCounts = {};

    for (const [key, value] of urlParams.entries()) {
      if (key.match(/^\d+:\d+$/)) {
        const [variantId, quantity] = key.split(':');
        const index = variantSeenCounts[variantId] || 0;
        const propertiesValues = propertiesMap.get(variantId) || [];
        const propertiesParam = propertiesValues[index];
        variantSeenCounts[variantId] = index + 1;
        let properties = {};

        if (propertiesParam) {
          try {
            const decodedProperties = JSON.parse(atob(propertiesParam));
            properties = decodedProperties.reduce((acc, prop) => {
              acc[prop[0]] = prop[1];
              return acc;
            }, {});
          } catch (e) {
            console.error(`Error decoding or processing properties for variant ${variantId}:`, e);
          }
        }

        products.push({
          id: variantId,
          quantity: parseInt(quantity, 10),
          properties: properties,
        });
      }
    }

    if (products.length > 0) {
      console.log('Parsed products from URL:', products);
      await this.updateCart(products);
    }
  }

  async updateCart(products) {
    const loadingOverlay = this.querySelector('.loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.style.display = 'block';
    }

    try {
      console.log('Clearing cart...');
      await fetch(`${routes.cart_url}/clear`, { ...fetchConfig() });
      console.log('Cart cleared.');

      console.log('Adding products to cart...');
      const body = JSON.stringify({
        items: products,
      });

      const response = await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body });
      const cartData = await response.json();

      console.log('Products added to cart:', cartData);
      window.location.href = routes.cart_url;
    } catch (error) {
      console.error('Error updating cart:', error);
    } finally {
      if (loadingOverlay) {
        loadingOverlay.style.display = 'none';
      }
    }
  }
}

customElements.define('cart-share-link', CartShareLink);

class ConsoleLogModal extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    
    // Check if dev mode should be enabled
    const urlParams = new URLSearchParams(window.location.search);
    const testParam = urlParams.get('test') === 'true';
    const storedState = localStorage.getItem('dev-console-modal-open') === 'true';
    
    if (testParam || storedState) {
      // Initialize logs array if not already done
      if (!window.__devConsoleLogs) {
        window.__devConsoleLogs = [];
      }
      
      // Update early interception to notify this modal
      this.updateConsoleInterception();
      
      // Create modal structure
      this.createModal();
      
      // Load pre-captured logs
      this.loadPreCapturedLogs();
      
      // Show modal if test param is present or if stored state says it should be open
      if (testParam || localStorage.getItem('dev-console-modal-open') === 'true') {
        this.show();
      }
    }
  }

  updateConsoleInterception() {
    // Register this modal instance so early interception can notify it
    window.__devConsoleModalInstance = this;
  }

  loadPreCapturedLogs() {
    // Pre-captured logs are already in window.__devConsoleLogs
    // No need to do anything, they'll be rendered when modal opens
  }

  createModal() {
    this.innerHTML = `
      <div class="console-modal__overlay" role="dialog" aria-modal="true" aria-label="Console Logs">
        <div class="console-modal__content">
          <div class="console-modal__header">
            <h2 class="console-modal__title">Console Logs</h2>
            <div class="console-modal__actions">
              <button class="console-modal__clear" aria-label="Clear logs">Clear</button>
              <button class="console-modal__close" id="ConsoleModalClose" aria-label="Close console">${this.getCloseIcon()}</button>
            </div>
          </div>
          <div class="console-modal__logs" role="log" aria-live="polite"></div>
        </div>
      </div>
    `;

    // Add event listeners
    this.querySelector('.console-modal__close').addEventListener('click', () => this.hide());
    this.querySelector('.console-modal__clear').addEventListener('click', () => this.clearLogs());

    // Handle escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.hide();
      }
    });

    // Track element hovers inside the modal
    this.setupElementHoverTracking();
  }

  setupElementHoverTracking() {
    const modalElement = this;
    const modalContent = this.querySelector('.console-modal__content');
    
    // Remove existing listener if any (to avoid duplicates)
    if (this._hoverHandler) {
      document.removeEventListener('mouseover', this._hoverHandler, true);
    }

    // Track which buttons have been hovered to avoid duplicate logs
    const hoveredButtons = new WeakSet();
    const self = this;

    // Track hovers on the entire document (site content) - only buttons
    this._hoverHandler = function(e) {
      const element = e.target;
      
      // Skip if element is inside the modal
      if (modalElement.contains(element)) {
        return;
      }
      
      // Only track buttons
      const button = element.closest('button');
      if (!button) {
        return;
      }
      
      // Skip if already logged
      if (hoveredButtons.has(button)) {
        return;
      }
      
      // Skip body, html
      if (button === document.body || button === document.documentElement) {
        return;
      }
      
      hoveredButtons.add(button);
      self.logElementHover(button);
      
      // Reset on mouseleave so it can be logged again
      button.addEventListener('mouseleave', () => {
        hoveredButtons.delete(button);
      }, { once: true });
    };

    // Listen to document with capture phase to catch all hovers
    document.addEventListener('mouseover', this._hoverHandler, true);
  }

  logElementHover(element) {
    try {
      const elementDetails = {
        tagName: element.tagName,
        id: element.id || null,
        className: element.className || null,
        textContent: element.textContent?.trim().substring(0, 100) || null,
        ariaLabel: element.getAttribute('aria-label') || null,
        role: element.getAttribute('role') || null,
        type: element.type || null,
        name: element.name || null,
        href: element.href || null,
        src: element.src || null,
        alt: element.alt || null,
        dataset: Object.keys(element.dataset).length > 0 ? element.dataset : null,
        attributes: {}
      };

      // Collect all attributes
      if (element.attributes && element.attributes.length > 0) {
        Array.from(element.attributes).forEach(attr => {
          if (!['id', 'class', 'aria-label', 'role', 'type', 'name', 'href', 'src', 'alt'].includes(attr.name)) {
            elementDetails.attributes[attr.name] = attr.value;
          }
        });
        if (Object.keys(elementDetails.attributes).length === 0) {
          elementDetails.attributes = null;
        }
      } else {
        elementDetails.attributes = null;
      }

      // Remove null values for cleaner output
      const cleanedDetails = Object.fromEntries(
        Object.entries(elementDetails).filter(([_, v]) => v !== null)
      );

      const logMessage = `[Button Hover] ${JSON.stringify(cleanedDetails, null, 2)}`;
      
      // Ensure logs array exists
      if (!window.__devConsoleLogs) {
        window.__devConsoleLogs = [];
      }
      
      // Add log directly to the array
      const timestamp = new Date().toLocaleTimeString();
      window.__devConsoleLogs.push({ type: 'info', message: logMessage, timestamp });
      
      // Limit log history
      if (window.__devConsoleLogs.length > 1000) {
        window.__devConsoleLogs.shift();
      }

      // Always update display if modal is open
      if (this.isOpen) {
        this.renderLogs();
      }
    } catch (error) {
      // Fallback: log error to console
      console.error('Error logging element hover:', error);
    }
  }

  getCloseIcon() {
    return '<svg class="icon" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L16 16M16 1L1 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  }

  show() {
    this.isOpen = true;
    this.setAttribute('open', '');
    localStorage.setItem('dev-console-modal-open', 'true');
    // Re-setup hover tracking in case modal was recreated
    this.setupElementHoverTracking();
    this.renderLogs();
  }

  hide() {
    this.isOpen = false;
    this.removeAttribute('open');
    localStorage.setItem('dev-console-modal-open', 'false');
    
    // Remove hover tracking when modal is closed
    if (this._hoverHandler) {
      document.removeEventListener('mouseover', this._hoverHandler, true);
      this._hoverHandler = null;
    }
  }

  clearLogs() {
    window.__devConsoleLogs = [];
    this.renderLogs();
  }

  renderLogs() {
    const logsContainer = this.querySelector('.console-modal__logs');
    if (!logsContainer) return;

    const logs = (window.__devConsoleLogs || []).filter(log => {
      // Filter out logs with [klarna-osm] or [Klaviyo / Onsite]
      // But keep [Button Hover] logs
      if (log.message && log.message.includes('[Button Hover]')) {
        return true;
      }
      return !log.message.includes('[klarna-osm]') && !log.message.includes('[Klaviyo / Onsite]');
    });
    
    logsContainer.innerHTML = logs.map(log => {
      return `<div class="console-modal__log console-modal__log--${log.type}">
        <span class="console-modal__timestamp">[${log.timestamp}]</span>
        <span class="console-modal__message">${this.escapeHtml(log.message)}</span>
      </div>`;
    }).join('');

    // Auto-scroll to bottom
    logsContainer.scrollTop = logsContainer.scrollHeight;
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

customElements.define('console-log-modal', ConsoleLogModal);